// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module--section--32D5N","sectionBgGrey":"section-module--sectionBgGrey--1oyX1","sectionTextCenter":"section-module--sectionTextCenter--2oDTp"};